export default __webpack_public_path__ + "static/media/theme.a31838ab.svg";